import React from "react";
import { contactFormSchema, SUCCESS_MSG } from "./schemas/schema";
import Form from "./fieldelement/Form";
import TextInput from "./fieldelement/TextInput";
import TextAreaInput from "./fieldelement/TextAreaInput";
import { Button } from "react-bootstrap";
import emailjs from "@emailjs/browser";
import { useRef } from "react";

const ContactForm = (props) => {
    const form = useRef();

  const onSubmit = async (data) => {
    // await SendMail(data);
    emailjs
      .send(
        "service_8r6t6mx",
        "template_m5t5yhn",
        data,
        "yRisInBIVRJON_ZnB"
      )
      .then(
        (result) => {
          console.log("Mail sent");
        },
        (error) => {
          console.log("Something Error");
        }
      );
  };

  const resetFunction = () => {
    console.log(form.current, "sd")
  }

  return (
    <div>
      <Form
        className='base-form general-enquiry-form'
        validationSchema={contactFormSchema}
        onSubmit={onSubmit}
        successMsg={SUCCESS_MSG}
        form={form}
        >
        <TextInput name='name' label='Name' className='input-field' />
        <TextInput
          name='email'
          label='Email'
          type='email'
          className='input-field'
        />
        <TextInput
          name='telephone'
          label='Contact Number'
          type='number'
          className='input-field'
        />
        <TextAreaInput name='message' label='Message' />
        <Button variant='success' type='submit' className='mx-3'>
          Send
        </Button>
        <Button variant='danger' type='reset' value='Reset' onClick={() => resetFunction()}>
          Reset
        </Button>
      </Form>
    </div>
  );
};

export default ContactForm;
